export const notNullOrUndefined = <TValue>(
  value: TValue | null | undefined | false
): value is TValue =>
  !(value === null || value === undefined || value === false)
